var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgEmpty404Forest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 360,
    viewBox: "0 0 387 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#DADDE3",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 268.5h337",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 268.5h7m353 0h7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297 319.344h31m-48 0h7",
    stroke: "#C3C6CB",
    strokeWidth: 2.5,
    opacity: 0.456,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 319.344h2.384",
    stroke: "#C4DAFB",
    strokeWidth: 2.5,
    opacity: 0.456,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 311.145h31m-48 0h7m-20 0h2.388M181 344.186h31m-48 0h7m-20 0h2.985",
    stroke: "#C3C6CB",
    strokeWidth: 2.5,
    opacity: 0.456,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.208 122.5)",
    stroke: "#DADDE3",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    cx: 36.213,
    cy: 51.255,
    rx: 36.213,
    ry: 50.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.99 71v74.775M35.404 86l-12.926-9.981M35.943 96l11.978-9.652",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.385 22.5)",
    stroke: "#DADDE3",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    cx: 57.615,
    cy: 98,
    rx: 57,
    ry: 98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.702 98v179.46M56.615 133L32.66 109.045m24.955 48.891l22.2-22.2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.385 11.5)",
    stroke: "#DADDE3",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    cx: 61.115,
    cy: 98,
    rx: 60.5,
    ry: 98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.702 98v179.46M59.615 133L35.66 109.045m24.955 48.891l22.2-22.2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.714 326.522c0 1.381-12.47 2.5-27.857 2.5-15.387 0-27.857-1.119-27.857-2.5 0-1.38 12.47-2.5 27.857-2.5 15.387 0 27.857 1.12 27.857 2.5",
    fillOpacity: 0.15,
    fill: "#020202",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 79.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#191816",
    fill: "#137DFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M102.887 183.758h58.171v35.607h-58.171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#126CF0",
    d: "M154.935 194.413h6.123v24.492h-3.061zm-52.048 0h6.124l-3.062 24.492h-3.062zm27.555 10.715h3.062l4.592 13.777H125.85z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#191816",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M102.887 183.758h58.171v35.607h-58.171zm29.086 22.962v12.614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.973 126.475c3.631.007 7.243-.53 10.715-1.592v-5.48a30.28 30.28 0 0 1-21.43 0v5.48a36.435 36.435 0 0 0 10.715 1.592z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.366 169.169c.002-19.43-13.887-36.364-33.678-41.064v-7.171c-3.416 1.231-17.942 1.257-21.43 0v7.171C105 133 70 144 61 149c6.667 18.667 20 22.333 40 11 0 4.664 1.852 8.843 1.852 15.373 0 22.688 53.03-.046 64.33.67.856.054 3.918-2.237 9.184-6.874z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.455 133.328a44.57 44.57 0 0 0-6.643-2.964c-.704 2.623-3.062 18.152-16.686 18.152-11.328 0-14.39-9.6-16.686-18.152a44.712 44.712 0 0 0-6.797 2.964c.49 2.36 11.236 32.29-5.602 41.787v19.359h58.017v-19.359c-16.839-9.496-6.123-39.426-5.603-41.787z",
    fill: "#E7F0FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4DAFB",
    d: "M151.873 166.858l9.185 6.123v21.432h-6.123zm-39.801 0l-9.22 7.582.035 19.973h6.124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.455 133.328a44.57 44.57 0 0 0-6.643-2.964c-.704 2.623-3.062 18.152-16.686 18.152-11.328 0-14.39-9.6-16.686-18.152a44.712 44.712 0 0 0-6.797 2.964c.49 2.36 11.236 32.29-5.602 41.787-.24.686-.36 3.029-.36 7.028 0 3.8.12 7.91.36 12.33h58.017V175.115c-16.839-9.496-6.123-39.426-5.603-41.787z",
    stroke: "#191816",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.774 65.586c0-21.004-16.236-38.031-38.78-38.031-22.546 0-40.822 17.027-40.822 38.031v24.721c0 20.917 20.71 32.158 40.821 32.158 20.111 0 38.78-15.044 38.78-32.158v-24.72z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.911 52.983c17.232 0 34.87-2.95 41.332-.978 1.298.396.312 1.58.295 2.28-.032 1.364-.295 2.355-.295 2.355-9.185 2.466-19.279 9.185-38.392 9.185-19.113 0-32.025-6.719-38.148-9.185 0 0-.151-1.035-.307-2.354-.09-.751-1.277-1.817.307-2.28 6.624-1.94 18.682.977 35.208.977z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.716 23.244c-.97-1.738-1.855-3.663-2.655-5.776-1.199-3.17-3.422-5.2-6.615-2.88-3.192 2.32-2.797 6.682-.886 8.86 1.273 1.451 3.67 2.687 7.192 3.707 4.5.702 3.072-.012 2.964-3.911z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#D12A0F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.84 26.16c-.048-3.461.204-6.71.754-9.746.826-4.554-.35-8.494-5.718-8.024-5.37.47-7.974 5.854-7.27 9.747.47 2.596 2.408 5.729 5.812 9.4 3.331-.006 3.086 0 6.421-1.377z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#D12A0F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.681 28.571c1.794-3.522 4.158-6.725 7.09-9.61 4.399-4.326 6.113-9.529-.187-13.166-6.3-3.637-13.303.22-15.502 5.008-1.466 3.193-2.143 8.755-2.03 16.687 3.264.046 5.63.367 10.63 1.081z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#D12A0F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.316 110.826c2.196 1.268 4.929.647 6.103-1.387.783-1.355 1.3-5.312 1.55-11.87-5.553 3.496-8.721 5.922-9.504 7.278-1.174 2.034-.346 4.71 1.85 5.979z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#D12A0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.318 110.826c2.196-1.268 3.025-3.945 1.85-5.979-.782-1.356-3.95-3.782-9.504-7.278.25 6.558.768 10.515 1.55 11.87 1.175 2.034 3.907 2.655 6.104 1.387z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#D12A0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.267 91.982c.074 4.254 2.124 6.088 7.76 5.99 5.635-.1 7.62-2.004 7.545-6.257l-15.305.267z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFD7A7",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.688 91.848c0-7.025-2.824-12.246-10.715-12.246s-10.716 5.22-10.716 12.246c4.763 1.021 8.335 1.531 10.716 1.531 2.381 0 5.953-.51 10.715-1.53z",
    fill: "#FFD7A7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09 81.429c-.222 2.621-.466 4.385-.733 5.29-1.139 3.86-2.39 5.292-2.39 5.292h4.684c.127-2.881.127-4.645 0-5.291-.127-.647-.648-2.41-1.561-5.291zm-16.466 0c.2 2.547.443 4.31.733 5.29 1.031 3.498 2.39 5.292 2.39 5.292h-4.685c-.127-2.881-.127-4.645 0-5.291.127-.647.648-2.41 1.562-5.291z",
    fill: "#E49712",
    opacity: 0.358
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.688 91.848c0-7.025-2.824-12.246-10.715-12.246s-10.716 5.22-10.716 12.246c4.763 1.021 8.335 1.531 10.716 1.531 2.381 0 5.953-.51 10.715-1.53z",
    stroke: "#191816",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEDED",
    cx: 159.883,
    cy: 90.981,
    r: 3.929
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEDED",
    cx: 104.673,
    cy: 90.981,
    r: 3.929
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    cx: 150.342,
    cy: 71.948,
    r: 4.592
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    cx: 113.603,
    cy: 71.948,
    r: 4.592
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.627 219.905v16.37h10.246v-16.369h-10.246zm-29.313.093v16.37h10.247v-16.37h-10.247z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFD7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.22 243.398c-.914-.005-1.757-.79-2.213-2.058-.441-1.269-.441-2.814 0-4.083 1.37-3.795 3.903-6.124 6.637-6.105h1.372c2.733-.012 5.263 2.315 6.637 6.105.441 1.27.441 2.814 0 4.083-.457 1.269-1.3 2.053-2.212 2.058h-10.222z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#C4DAFB",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.175 246.46c-1.279-.004-2.458-.592-3.097-1.544a2.76 2.76 0 0 1 0-3.062c1.92-2.846 5.464-4.593 9.292-4.579h1.92c3.826-.009 7.368 1.737 9.292 4.58a2.76 2.76 0 0 1 0 3.06c-.64.953-1.819 1.54-3.097 1.545h-14.31z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#EDEDED",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.858 243.398c-.913-.005-1.756-.79-2.212-2.058-.442-1.269-.442-2.814 0-4.083 1.37-3.795 3.902-6.124 6.637-6.105h1.371c2.734-.012 5.263 2.315 6.638 6.105.441 1.27.441 2.814 0 4.083-.457 1.269-1.3 2.053-2.213 2.058h-10.221z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#C4DAFB",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.528 246.46c-1.279-.004-2.458-.592-3.097-1.544a2.76 2.76 0 0 1 0-3.062c1.92-2.846 5.464-4.593 9.292-4.579h1.92c3.826-.009 7.368 1.737 9.292 4.58a2.76 2.76 0 0 1 0 3.06c-.639.953-1.819 1.54-3.097 1.545h-14.31z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#EDEDED",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.201,
    d: "M141.253 220h9.286v3.571h-9.286zm-29.073.149h9.286v3.017h-9.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.357 41.022c18.168-2.752 41.25-3.149 60.926 0 3.266 2.248 5.919 6.433 7.96 12.556h-76.54c2.04-4.082 4.592-8.267 7.654-12.556z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#E7F0FD",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.973 47.455c27.42 0 35.208 6.719 38.27 6.719-9.185 2.466-15.07 5.527-38.151 5.527-23.081 0-32.266-3.061-38.39-5.527 0 0 10.85-6.719 38.27-6.719z",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#C4DAFB",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11 173.972c-.1.014-.216.04-.317.068l-4.59-4.79c.13-.285.187-.597.144-.936-.144-.922-1.05-1.574-2.029-1.438-.978.136-1.669.99-1.525 1.913.029.19.086.353.173.516l-2.634 2.985a2.124 2.124 0 0 0-.72-.041 1.67 1.67 0 0 0-.373.095l-1.022-1.058c.13-.285.187-.597.144-.937-.144-.922-1.05-1.574-2.029-1.438-.978.136-1.669.99-1.525 1.913.144.923 1.05 1.574 2.029 1.439.115-.014.216-.041.316-.068l1.05 1.099c-.114.271-.158.57-.114.882.144.922 1.05 1.574 2.029 1.438.978-.136 1.669-.99 1.525-1.913a1.765 1.765 0 0 0-.187-.543l2.619-2.971c.23.067.489.081.748.054.1-.014.216-.04.316-.068l4.59 4.79a1.7 1.7 0 0 0-.143.936c.143.922 1.05 1.574 2.028 1.438.979-.136 1.67-.99 1.526-1.913-.144-.936-1.05-1.588-2.03-1.452zm.033-16.279c-.962.15-1.642 1.096-1.5 2.118.028.24.113.465.226.675l-1.571 2.013a1.677 1.677 0 0 0-.821-.076c-.142.015-.27.06-.382.106l-1.274-1.487c.155-.33.226-.72.17-1.111-.142-1.021-1.034-1.742-1.996-1.592-.963.135-1.642 1.081-1.5 2.102.027.24.098.45.197.646l-1.656 2.117a1.58 1.58 0 0 0-.793-.075c-.962.15-1.642 1.096-1.5 2.117.142 1.022 1.033 1.742 1.996 1.592.962-.15 1.642-1.096 1.5-2.117a1.802 1.802 0 0 0-.226-.676l1.656-2.087c.255.09.538.12.821.09.142-.015.269-.06.382-.105l1.274 1.487c-.155.33-.226.72-.17 1.11.142 1.022 1.034 1.743 1.996 1.592.963-.15 1.642-1.096 1.5-2.117a1.632 1.632 0 0 0-.212-.646l1.586-2.042c.255.09.524.12.793.075.962-.15 1.642-1.096 1.5-2.117-.127-1.036-1.033-1.742-1.996-1.592z",
    stroke: "#126CF0",
    strokeWidth: 0.25,
    fill: "#126CF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.997 160.735c.72 18.751 2.969 29.107 6.747 31.069 3.777 1.96 5.179-2.587 4.205-13.644 1.451 6.005 3.13 8.315 5.035 6.93 2.31-1.678 1.263-7.976 1.263-7.976s1.678 2.31 3.988.631c2.31-1.678-5.38-26.485-10.367-32.025",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M170.243 169.92h6.123v6.123h-6.123z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    cx: 168.931,
    cy: 178.036,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    cx: 174.824,
    cy: 175.714,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(84 -.526 103.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.508 13.14c5.883 30.306 10.937 46.304 15.161 47.995 3.696.889 4.65-3.095 2.861-11.951.343 4.75 1.725 6.703 4.147 5.86 2.422-.844 2.766-3.351 1.032-7.523 1.223 2.478 2.536 3.168 3.94 2.07 2.107-1.647 2.777-28.46-1.179-34.728",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    cx: 60.149,
    cy: 46.282,
    r: 1.531
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191816",
    transform: "rotate(-41 65.8 47.68)",
    cx: 65.8,
    cy: 47.679,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76 42.059l65.163 7.007",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#C4DAFB",
    transform: "rotate(6 47.564 46.35)",
    x: 13.064,
    y: 43.85,
    width: 69,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.001 41.815c2.2 7.152 4.412 10.585 6.636 10.3 2.224-.286 2.44-3.77.648-10.452",
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#191816",
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(-90 60.5 114)",
    x: 42.5,
    y: 85.5,
    width: 36,
    height: 57,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.644 119.583a.622.622 0 0 1-.458-.186.622.622 0 0 1-.186-.457v-8.824c0-.182.062-.337.186-.465a.61.61 0 0 1 .458-.193c.18 0 .336.064.464.193a.634.634 0 0 1 .193.465v3.804h5.42v-3.804c0-.182.063-.337.187-.465a.61.61 0 0 1 .457-.193c.181 0 .336.064.465.193a.634.634 0 0 1 .193.465v8.824a.61.61 0 0 1-.193.457.646.646 0 0 1-.465.186.622.622 0 0 1-.457-.186.622.622 0 0 1-.186-.457v-3.805h-5.42v3.805a.61.61 0 0 1-.194.457.646.646 0 0 1-.464.186zm13.157.072c-1.163 0-2.071-.332-2.724-.994-.654-.663-.98-1.595-.98-2.796 0-.677.124-1.302.372-1.874a3.185 3.185 0 0 1 1.144-1.387c.515-.353 1.149-.53 1.902-.53.705 0 1.316.165 1.83.494a3.19 3.19 0 0 1 1.173 1.316c.267.548.4 1.146.4 1.795a.632.632 0 0 1-.178.457.634.634 0 0 1-.48.186h-4.847c.076.668.324 1.187.743 1.56.42.371 1.006.557 1.76.557.4 0 .75-.038 1.05-.114.3-.077.594-.186.88-.33a.568.568 0 0 1 .258-.057c.152 0 .286.053.4.158a.52.52 0 0 1 .172.4c0 .21-.124.386-.372.53-.372.21-.74.366-1.101.471-.363.105-.83.158-1.402.158zm1.83-4.39c-.028-.468-.15-.859-.364-1.174a1.969 1.969 0 0 0-.794-.693 2.233 2.233 0 0 0-.958-.222c-.324 0-.644.074-.958.222a1.92 1.92 0 0 0-.787.693c-.21.315-.329.706-.357 1.173h4.219zm3.647 4.318a.622.622 0 0 1-.457-.186.622.622 0 0 1-.186-.457v-9.282c0-.181.062-.336.186-.465a.61.61 0 0 1 .457-.193.64.64 0 0 1 .472.186.64.64 0 0 1 .186.472v9.282a.61.61 0 0 1-.193.457.646.646 0 0 1-.465.186zm3.562 3.29a.61.61 0 0 1-.458-.194.646.646 0 0 1-.186-.464v-9.425c0-.181.062-.334.186-.458a.622.622 0 0 1 .458-.186c.18 0 .336.062.464.186a.61.61 0 0 1 .193.458v.372c.696-.725 1.512-1.087 2.446-1.087.591 0 1.151.15 1.68.45.53.3.959.74 1.288 1.316.328.577.493 1.251.493 2.024 0 .772-.165 1.447-.493 2.023-.33.577-.758 1.016-1.288 1.316-.529.3-1.089.45-1.68.45-.934 0-1.75-.362-2.446-1.086v3.647a.64.64 0 0 1-.186.472.64.64 0 0 1-.471.185zm2.917-4.434c.706 0 1.273-.224 1.702-.672.429-.448.643-1.082.643-1.902 0-.82-.214-1.454-.643-1.902-.43-.448-.996-.673-1.702-.673-.439 0-.85.098-1.237.294a3.533 3.533 0 0 0-1.023.78v3.002a3.54 3.54 0 0 0 1.023.78c.386.195.798.293 1.237.293zm6.35-1.688a.498.498 0 0 1-.343-.114.43.43 0 0 1-.143-.3l-.258-4.72v-1.416c0-.21.072-.386.215-.529a.719.719 0 0 1 .529-.214c.21 0 .384.071.522.214.138.143.207.32.207.53v1.415l-.257 4.72a.443.443 0 0 1-.136.3.47.47 0 0 1-.336.114zm0 2.818a.811.811 0 0 1-.594-.25.828.828 0 0 1-.25-.608c0-.23.084-.427.25-.594a.811.811 0 0 1 .594-.25.83.83 0 0 1 .608.25c.167.167.25.365.25.594a.828.828 0 0 1-.25.608.828.828 0 0 1-.608.25z",
    stroke: "#191816",
    strokeWidth: 0.5,
    fill: "#333",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty404Forest);
export default __webpack_public_path__ + "static/media/empty-404--forest.e073c3d12e73b8ed678b6a7f83d7545f.svg";
export { ForwardRef as ReactComponent };